import CustomProjectFormCollapse from './CustomCollapse/CustomProjectFormCollapse'
import ProjectFormButtonContinue from './ProjectFormButtonContinue/ProjectFormButtonContinue'
import ProjectFormCertification from './ProjectFormCertification/ProjectFormCertification'
import ProjectFormConfiguration from './ProjectFormConfiguration/ProjectFormConfiguration'
import ProjectFormContent from './ProjectFormContent/ProjectFormContent'
import ProjectFormDefinition from './ProjectFormDefinition/ProjectFormDefinition'
import ProjectFormDocumentation from './ProjectFormDocumentation/ProjectFormDocumentation'
import ProjectFormFooter from './ProjectFormFooter/ProjectFormFooter'
import ProjectFormLocation from './ProjectFormLocation/ProjectFormLocation'
import ProjectFormStock from './ProjectFormStock/ProjectFormStock'
import ProjectFormTaxRelief from './ProjectFormTaxRelief/ProjectFormTaxRelief'

export {
  CustomProjectFormCollapse,
  ProjectFormCertification,
  ProjectFormConfiguration,
  ProjectFormFooter,
  ProjectFormContent,
  ProjectFormDefinition,
  ProjectFormDocumentation,
  ProjectFormLocation,
  ProjectFormStock,
  ProjectFormTaxRelief,
  ProjectFormButtonContinue,
}
